import { FC } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { IUserInforResponse } from 'Data/interfaces/Auth/IUserInfoResponse';
import { getCurrentTenant, getTenants } from 'Store/Tenant/Tenant.selector';
import { Mixpanel } from 'Utils/MixPanel';
import Button from 'Components/UI/Button';
import { Icon } from 'Components/UI';
import { Container, Left } from './styles';

interface ICallToAction {
  userInfo?: IUserInforResponse;
}

const CallToAction: FC<ICallToAction> = ({
  userInfo,
}) => {
  const navigate = useNavigate();
  const tenants = useSelector(getTenants);
  const currentTenant = useSelector(getCurrentTenant);
  const currentRole = userInfo?.CurrentRoleFk;

  const openUpgradePremium = () => {
    Mixpanel.track({
      name: 'CALL_T0_ACTION',
      props: {
        origin: 'convidar-usuarios-modal',
        originPath: window.location.pathname,
      },
      userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });

    if (currentRole === 1) {
      navigate('/faturamento/planos');
    } else {
      window.open('https://bim.maletadoengenheiro.com.br/seja-premium');
    }
  };

  return (
    <Container>
      <Left>
        <span className='title'>
          {currentRole === 1
            ? 'Atenção: você atingiu o limite de usuários gratuitos!'
            : 'Atenção: sua empresa atingiu o limite de usuários gratuitos!'
          }
        </span>
        <span className='text'>
          {currentRole === 1
            ? 'Dê um upgrade na sua conta gratuita para convidar mais usuários'
            : 'Dê um upgrade na conta da sua empresa gratuita para convidar mais usuários'
          }
        </span>
      </Left>
      <Button
        ispremium='true'
        className='upBtn'
        onClick={openUpgradePremium}
      >
        <Icon
          icon='crown'
          customSize={14}
          className='crownIcon'
        />
        <span className='text'>Fazer upgrade</span>
      </Button>
    </Container>
  );
};

export default CallToAction;
